/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createQuickbooksConnectedResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type QuickbooksConnectedResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/quickbooks/connected
 */
export interface ConnectedRequestBuilder extends BaseRequestBuilder<ConnectedRequestBuilder> {
    /**
     * Answers whether this organization's QuickBooks connection is working. It is a live check, not a look at stored settings: the API calls QuickBooks and reports true only if the connected company answers, so a connection revoked at the QuickBooks end reads as false without anything having to be updated here. False covers every reason equally — never connected, disconnected, or expired — so drive a 'connect QuickBooks' prompt from it rather than a diagnosis. Because the check is a live call it is slower than a settings read; don't poll it.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<QuickbooksConnectedResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<QuickbooksConnectedResponse | undefined>;
    /**
     * Answers whether this organization's QuickBooks connection is working. It is a live check, not a look at stored settings: the API calls QuickBooks and reports true only if the connected company answers, so a connection revoked at the QuickBooks end reads as false without anything having to be updated here. False covers every reason equally — never connected, disconnected, or expired — so drive a 'connect QuickBooks' prompt from it rather than a diagnosis. Because the check is a live call it is slower than a settings read; don't poll it.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ConnectedRequestBuilderUriTemplate = "{+baseurl}/api/quickbooks/connected";
/**
 * Metadata for all the requests in the request builder.
 */
export const ConnectedRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ConnectedRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createQuickbooksConnectedResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
